import { UPDATE_MASTER_DATE} from '../types';
export const updateMasterData =(list= {})=>{

    return {
        type : UPDATE_MASTER_DATE,
        masterData : list
        // isLoading : isLoading
    }
}
